import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import config from '../config';

export const TestContract = () => {
  const { contractId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContract = async () => {
      try {
        const token = localStorage.getItem('access_token');
        console.log('Token:', token);
        console.log('Contract ID:', contractId);
        
        const response = await fetch(config.getApiUrl(`/marketplace/contracts/${contractId}/`), {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        
        console.log('Response status:', response.status);
        
        if (response.ok) {
          const json = await response.json();
          console.log('Contract data:', json);
          setData(json);
        } else {
          const text = await response.text();
          console.log('Error response:', text);
          setError(`Status: ${response.status}`);
        }
      } catch (err) {
        console.error('Fetch error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchContract();
  }, [contractId]);

  if (loading) {
    return <div className="p-8 text-center">در حال بارگذاری...</div>;
  }

  if (error) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-red-600 text-xl">خطا</h2>
        <p>{error}</p>
        <button onClick={() => window.location.reload()} className="mt-4 bg-blue-600 text-white px-4 py-2 rounded">
          تلاش مجدد
        </button>
      </div>
    );
  }

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold">تست قرارداد</h1>
      <pre className="bg-gray-100 p-4 mt-4 rounded overflow-auto">
        {JSON.stringify(data, null, 2)}
      </pre>
    </div>
  );
};
